import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        10/292, Ground Floor, Sundaracharyula Street, Gandhi Road, Proddatur. 516360
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        8790590588
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        info@brrdiagnostics.in <br />
        brrdiagnostics@gmail.com
      </li>
    </ul>
  );
}
